import { render, staticRenderFns } from "./HuaxianFinanceProject.vue?vue&type=template&id=10c4a70d&scoped=true&"
import script from "./HuaxianFinanceProject.vue?vue&type=script&lang=js&"
export * from "./HuaxianFinanceProject.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianFinanceProject.vue?vue&type=style&index=0&id=10c4a70d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c4a70d",
  null
  
)

export default component.exports